import React from "react";
import { Link } from "react-router-dom";
import logo from "../../media/images/logo.png";
import ps from "../../media/images/icons/playStore.jpg";
import as from "../../media/images/icons/appStore.jpg";

const Footer = () => {
  return (
    <div>
      <div className="footer">
        <div className="footer-content">

          <div className="footer-col">

          <div className="footer-images footer-web-images">

            
               

{/* RepairBuddy */}

            <img className="footer-logo" src={logo} alt="logo-white" />


            <div>
              <Link   ><img className="footer-app" src={ps}  /></Link>
              <Link  ><img className="footer-app" src={as}  /></Link>
            </div>
          </div>

          </div>

          <div className="footer-col">
            <div className="footer-heading-1">About Us</div>
            {/* <div className="footer-text">Maecens rhoncus molese conubia <br />lores mauris class etiam potenti been <br />nonum lectus folish consequat</div> */}
            <div className="footer-text">
              Your trusted partner for fast, <br />
              affordable, and expert AC services <br />
              at your doorstep across Delhi-NCR.
            </div>

            {/* <div className="footer-heading-2">Emergency :</div>
            <a
              href="tel:+919220407009"
              target="blank"
              className="footer-heading-3"
            >
              +91 9220-407-009
            </a> */}
          </div>

          <div className="footer-col">
            <div className="footer-heading-1">Services</div>
            <div className="footer-text">_Heating Service</div>
            <div className="footer-text">_Installation</div>
            {/* <div className="footer-text">_Quality Testing</div> */}
            <div className="footer-text">_Compressure</div>
            <div className="footer-text">_Maintanence</div>
            <div className="footer-text">_Cooler Cleaning</div>
          </div>

          <div className="footer-col">
            <div className="footer-heading-1">Information</div>
            <div className="footer-text">Delhi NCR</div>
            {/* <div className="footer-heading-4">Support:</div>
            <a href="tel:+919220407009"
              target="blank" className="footer-text">+91 9220-407-009</a> */}
            <div className="footer-heading-4">Email:</div>
            <div className="footer-text">repairbuddyonline@gmail.com</div>

            <Link to="/privacy-policy" target="_blank" className="footer-text">Privacy Policy Page</Link>
          </div>


          <div className="footer-images footer-mobile-images">
             <div>
              {/* <Link to="https://play.google.com/store/apps/details?id=com.repairbuddyapp" target="_blank" ><img className="footer-app" src={ps}  /></Link>
              <Link to="https://play.google.com/store/apps/details?id=com.repairbuddyapp" target="_blank" ><img className="footer-app" src={as}  /></Link> */}


              <img className="footer-app" src={as}  />
              <img className="footer-app" src={ps}  />
            </div>
          </div>


          {/* <div className="footer-col">
            <div className="footer-heading-1">Newsletter</div>
            <div className="footer-text">Get every week update from RepairBuddy</div>
            <form>
                <input type="text" placeholder="Enter Email" />
                <button>Subscirbe Now</button>
            </form>
          </div> */}
        </div>
        <div className="footer-cc">
          <div>
            <div className="footer-cc-text">
              Copyright © 2025 <span>RepairBuddy</span>. All Rights Reserved.
            </div>
            <div className="footer-cc-social">
              <a to="">
                <i class="fa-brands fa-youtube"></i>
              </a>
              <a to="">
                <i class="fa-brands fa-instagram"></i>
              </a>
              <a >
                <i class="fa-brands fa-facebook-f"></i>
              </a>
              <a >
                <i class="fa-brands fa-google"></i>
              </a>
              <a >
                <i class="fa-brands fa-twitter"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
